export default {
  'themes.light-default': 'Açık varsayılan',
  'themes.light-high-contrast': 'Açık yüksek kontrast',
  'themes.light-protanopia-and-deuteranopia': 'Açık Protanopia & Deuteranopia',
  'themes.light-tritanopia': 'Açık Tritanopia',
  'themes.dark-default': 'Koyu varsayılan',
  'themes.dark-high-contrast': 'Koyu yüksek kontrast',
  'themes.dark-protanopia-and-deuteranopia': 'Koyu Protanopia & Deuteranopia',
  'themes.dark-tritanopia': 'Koyu Tritanopia',
  'themes.dark-dimmed': 'Karartılmış',
};
